<template>
    <span>{{ text }}</span>
</template>

<script>

const SHOW_CASES = {
    FIRST: 'first',
    LAST: 'last',
    FULL: 'full-name',
};

export default {

    props: {
        model: {
            type: Object,
            default: null,
        },
        modelFirstNameKey: {
            type: String,
            default: 'first_name',
        },
        modelLastNameKey: {
            type: String,
            default: 'last_name',
        },
        firstName: {
            type: String,
        },
        lastName: {
            type: String,
        },
        show: {
            type: String,
            default: SHOW_CASES.FIRST,
        },
        plural: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        text() {
            return this.pluralize(this.content);
        },

        content() {
            let object = this;
            let keys = {};
            keys[ SHOW_CASES.FIRST ] = 'firstName';
            keys[ SHOW_CASES.LAST ] = 'lastName';

            if (this.model !== null) {
                object = this.model;
                keys[ SHOW_CASES.FIRST ] = this.modelFirstNameKey;
                keys[ SHOW_CASES.LAST ] = this.modelLastNameKey;
            }

            switch (this.show) {
                case SHOW_CASES.FIRST:
                    return object[ keys[ SHOW_CASES.FIRST ] ];
                case SHOW_CASES.LAST:
                    return object[ keys[ SHOW_CASES.LAST ] ];
                case SHOW_CASES.FULL:
                    return object[ keys[ SHOW_CASES.FIRST ] ] + ' ' + object[ keys[ SHOW_CASES.LAST ] ];
            }
        },
    },

    methods: {
        pluralize(text) {
            if (!this.plural) return text;

            if (text.slice(-1).toLowerCase() === 's') {
                return text + "'";
            }

            return text + "'s";
        }
    }
}

</script>



// WEBPACK FOOTER //
// resources/js/components/elements/PersonName.vue